import { useState } from "react";
import TopHeader from "../Header/TopHeader";
import BottomHeader from "../Header/BottomHeader";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getCartProductsData } from "store/slices/cartSlice";
import { getGlobalSettingsData, getUserDetailsData, removeUserDetailsAction } from "store/slices/profileSlice";

import { localStorageEnum } from "utils/enum/enum";
import { getLocalStorageValue, removeLocalStorageValue, scrollToTop } from "utils/helper/helper";

import { ROUTE } from "utils/api/routes/clientRoute";

import CartAuthPopupWithoutLogin from "../CartAuthPopupWithoutLogin";
import WishlistAuthPopupWithoutLogin from "../WishlistAuthPopupWithoutLogin";

const StaticPageHeader = () => {
  const [isMobileViewSidebarOpen, setIsMobileViewSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token = getLocalStorageValue(localStorageEnum.ACCESS_TOKEN);

  const { cartProducts } = useSelector(getCartProductsData);
  const userDetails = useSelector(getUserDetailsData);
  const globalSetting = useSelector(getGlobalSettingsData);

  const signOutHandler = () => {
    removeLocalStorageValue(localStorageEnum.ACCESS_TOKEN);
    navigate(ROUTE.DASHBOARD);
    dispatch(removeUserDetailsAction({}));
  };

  return (
    <>
      <header className="static-page-header sticky-top bg-white shadow-sm border-bottom">
        <div className="navbar1 navbar-expand-lg navbar-light1">
          
          <div className="container ">
            
            {/* Logo */}
            <a
              className="navbar-brand cursor-pointer m-0"
              onClick={() => {
                setIsMobileViewSidebarOpen(false);
                navigate(ROUTE.DASHBOARD);
                scrollToTop();
              }}
            >
              <img
                src={"/Asset_24x.png"}
                alt="Logo"
                className="header-logo"
              />
            </a>

            {/* Right Section (empty for now) */}
            <div className="header-right d-flex align-items-center">
              {/* Future icons */}
            </div>

          </div>
        </div>
      </header>

      {/* Popups */}
      <CartAuthPopupWithoutLogin />
      <WishlistAuthPopupWithoutLogin />

      {/* CSS */}
      <style>{`


.navbar1 {
  &.navbar-light1 {
    z-index: 12;

    @media only screen and (max-width: 991.5px) {
      height: 0%;
      // position: fixed;
      width: 100%;
      // top: 29px;
      background-color: #fff !important;
      z-index: 11;
    }
  }

        .header-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .header-logo {
          width: 200px;
          height: 60px;
          object-fit: contain;
          transition: all 0.3s ease;
        }

        /* Tablet */
        @media (max-width: 992px) {
          .header-logo {
            width: 150px;
            height: 50px;
            margin-top: 0px;
          }
        }

        /* Mobile */
        @media (max-width: 576px) {
          .header-container {
            justify-content: center;
          }

          .header-logo {
            width: 120px;
            height: 40px;
          }
        }
      `}</style>
    </>
  );
};

export default StaticPageHeader;